module.exports = __webpack_public_path__ + "static/media/im-shopper@2x.4dee2472.svg";